import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { userKeys } from '../../cache-keys/userKeys';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { heartbeat_api } from '@axo/shared/data-access/api';

export function useSendHeartbeat(marketCountry: string) {
  const { state } = useContext(DataAccessContext);
  const client = useQueryClient();
  const api = useAPI();
  return useMutation(
    () => heartbeat_api.sendHeartbeat(api)(state.user.clientID, marketCountry),
    {
      onSuccess: (hb) =>
        client.invalidateQueries(
          userKeys.heartbeat({
            user: state.user.clientID,
            country: hb.Country,
          })
        ),
    }
  );
}
